import axios from 'axios';
import axiosClient from 'api/axiosClient';
import { AppCustomDialogHelper } from 'general/components/AppDialogCustom';
import { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import AgencyCreateContractView from './components/AgencyCreateContractView';
import AgencySaleDialogView from './components/AgencySaleDialogView';
import { t } from 'i18next';
import DialogCreateAgencyReconciliation from 'features/ReconciliationReport/components/DialogCreateAgencyReconciliation';
import { AppDialogHelper } from 'general/components/AppDialog';
import SystemHelper from 'features/System/systemHelper';

const isRequestCancelled = (error) =>
  axios.isCancel(error) || error?.code === 'ERR_CANCELED' || error?.name === 'CanceledError';

// MARK: ---- CONSTANTS ----
export const AgencyConstants = {
  // config keys
  ConfigKey: {
    // ty le hoa hong nhuong quyen
    COMMISSION_RATE_SALE: 'COMMISSION_RATE_SALE',
    // ty le hoa hong ban lien ket
    COMMISSION_RATE_COINVESTOR: 'COMMISSION_RATE_COINVESTOR',
    // ty le hoa hong ban goi dau tu HTKD
    COMMISSION_RATE_GROUP: 'COMMISSION_RATE_GROUP',
    // ty le hoa hong gioi thieu mat bang
    COMMISSION_RATE_LANDLORD: 'COMMISSION_RATE_LANDLORD',
    // ty le hoa hong ban tru sac
    COMMISSION_RATE_CHARGEPOINT: 'COMMISSION_RATE_CHARGEPOINT',
  },
  // loai AGENCY
  AgencyType: {
    INDIVIDUAL: 'INDIVIDUAL', // cá nhân
    ORGANIZATION: 'ORGANIZATION', // tổ chức
  },
  // vai tro cua AGENCY
  AgencyRole: {
    SALE: 'SALE', // đại lý bán hàng
    INVESTOR: 'INVESTOR', // nhà đầu tư nhượng quyền
    COINVESTOR: 'COINVESTOR', // nhà đầu tư liên kết
    GROUP: 'GROUP', // nhà đầu tư HTKD
    LANDLORD: 'LANDLORD', // chủ mặt bằng
    CHARGEPOINT: 'CHARGEPOINT', // đối tác mua trụ sạc
    MAINTAINER: 'MAINTAINER', // kỹ thuật viên
    FLEET: 'FLEET', // DNVT
    VOUCHER_PARTNER: 'VOUCHER_PARTNER', // đối tác mua voucher
  },
  // loai don hang
  SaleOrderType: {
    INVESTOR: 'INVESTOR',
    COINVESTOR: 'COINVESTOR',
    GROUP: 'GROUP',
    LANDLORD: 'LANDLORD',
    CHARGEPOINT: 'CHARGEPOINT',
  },
  // loai hop dong
  ContractRole: {
    INVESTOR: 'INVESTOR',
    COINVESTOR: 'COINVESTOR',
    GROUP: 'GROUP',
    SALE: 'SALE',
    LANDLORD: 'LANDLORD',
    CHARGEPOINT: 'CHARGEPOINT',
    FRANCHISE: 'FRANCHISE',
    MAINTAINER: 'MAINTAINER',
  },
  // loai bien ban nghiem thu
  AcceptanceRole: {
    TECHNICAL: 'TECHNICAL',
    FINANCIAL: 'FINANCIAL',
  },
  // trang thai don hang
  SaleOrderStatus: {
    ORDERED: 'ORDERED', // Đã đặt hàng
    SHIPPING: 'SHIPPING', // Đang vận chuyển
    INSTALLING: 'INSTALLING', // Đang lắp đặt
    INSTALLED: 'INSTALLED', // Đã lắp đặt
    SIGNED: 'SIGNED', // Đã ký biên bản nghiệm thu
    PAID: 'PAID', // Đã thanh toán
    COMPLETED: 'COMPLETED', // Hoàn thành
    CANCELLED: 'CANCELLED', // Đã hủy
  },
  // trang thai investment
  InvestmentStatus: {
    PENDING: 'PENDING', // Mới đăng ký (NĐT HTKD tự đăng ký)
    COMPLETED: 'COMPLETED', // Đã ký hợp đồng thành công
    WITHDRAWED: 'WITHDRAWED', // Đã rút tiền (thực tế không có phương án này)
    TRANSFERRED: 'TRANSFERRED', // Đã chuyển gói đầu tư sang cho NĐT khác
  },
  // trai thai hop dong
  ContractStatus: {
    CREATED: 'CREATED', // Đã tạo
    ADMIN_SIGNED: 'ADMIN_SIGNED', // Đã ký bởi NĐH
    AGENCY_SIGNED: 'AGENCY_SIGNED', // Đã ký bởi NĐT
    CANCELLED: 'CANCELLED', // Đã hủy
    COMPLETED: 'COMPLETED', // Đã hoàn thành
    EXPIRED: 'EXPIRED', // Đã hết hạn
  },
  // loai hop dong
  ContractType: {
    DIGITAL: 'DIGITAL', // Hợp đồng điện tử
    PAPER: 'PAPER', // Hợp đồng giấy
  },
  // loai bien ban
  AcceptanceType: {
    DIGITAL: 'DIGITAL', // Biên bản điện tử
    PAPER: 'PAPER', // Biên bản giấy
  },
  // loai phu luc
  AppendixType: {
    DIGITAL: 'DIGITAL', // Phụ lục điện tử
    PAPER: 'PAPER', // Phụ lục giấy
  },
  // loai doi soat
  AgencyReconciliationRole: {
    SALE: 'SALE', // Đối soát với đại lý bán hàng
    INVESTOR: 'INVESTOR', // Đối soát với nhà đầu tư nhượng quyền
    COINVESTOR: 'COINVESTOR', // Đối soát với nhà đầu tư liên kết
    GROUP: 'GROUP', // Đối soát với nhà đầu tư HTKD
  },
  // trang thai doi soat
  AgencyReconciliationStatus: {
    CREATED: 'CREATED', // Đã tạo
    ADMIN_SIGNED: 'ADMIN_SIGNED', // Đã ký bởi NĐH
    AGENCY_SIGNED: 'AGENCY_SIGNED', // Đã ký bởi đối tác
    COMPLETED: 'COMPLETED', // Hoàn thành
  },
  // pham vi thue mat bang
  RentingType: {
    FULL: 'FULL', // Toàn bộ mặt bằng
    SLOT: 'SLOT', // Theo số chỗ đỗ xe
  },
  // trang thai mat bang
  PremiseStatus: {
    AVAILABLE: 'AVAILABLE', // Chưa thuê
    RENTED: 'RENTED', // Đã thuê
    DELETED: 'DELETED', // Đã bị xóa
  },
  // trang thai hop dong mat bang
  PremiseContractStatus: {
    CREATED: 'CREATED', // Đã tạo
    ADMIN_SIGNED: 'ADMIN_SIGNED', // Đã ký bởi NĐH
    AGENCY_SIGNED: 'AGENCY_SIGNED', // Đã ký bởi NĐT
    LANDLORD_SIGNED: 'LANDLORD_SIGNED', // Đã ký bởi chủ mặt bằng
    CANCELLED: 'CANCELLED', // Đã hủy
    COMPLETED: 'COMPLETED', // Đã hoàn thành
    EXPIRED: 'EXPIRED', // Đã hết hạn
  },
  // trang thai lich su giao dich
  AgencyTransactionStatus: {
    PAID: 'PAID', // Đã thanh toán
    REQUESTED: 'REQUESTED', // Đợi xử lý
    PROCESSING: 'PROCESSING', // Đang xử lý
    REJECTED: 'REJECTED', // Từ chối
    FAILED: 'FAILED', // Thất bại
  },
  // loai doi soat
  ReconciliationType: {
    DIGITAL: 'DIGITAL', // Đối soát điện tử
    PAPER: 'PAPER', // Đối soát giấy
  },
  // trang thai bien ban nghiem thu
  AcceptanceStatus: {
    CREATED: 'CREATED', // Đã tạo
    ADMIN_SIGNED: 'ADMIN_SIGNED', // Đã ký bởi KTV
    AGENCY_SIGNED: 'AGENCY_SIGNED', // Đã ký bởi NĐT
    CANCELLED: 'CANCELLED', // Đã hủy
    COMPLETED: 'COMPLETED', // Đã hoàn thành
  },
  // mo hinh chia se doanh thu
  EnergyCommissionMode: {
    FIXED_PER_KWH: 'FIXED_PER_KWH', // Hoa hồng cố định theo số điện
    PERCENT_INPUT: 'PERCENT_INPUT', // Hoa hồng tỉ lệ theo giá điện mua của nhà nước
    PERCENT_OUTPUT: 'PERCENT_OUTPUT', // Hoa hồng tỉ lệ theo giá điện bán ra
    PERCENT_PROFIT: 'PERCENT_PROFIT', // Hoa hồng tỷ lệ theo lợi nhuận
    FIXED_PER_MONTH: 'FIXED_PER_MONTH', // Cố định theo tháng
    FIXED_PER_KWH_PER_VEHICLE_TYPE: 'FIXED_PER_KWH_PER_VEHICLE_TYPE', // Doanh thu cố định theo kW điện bán ra
  },

  // trai thai phu luc
  AppendixStatus: {
    CREATED: 'CREATED', // Đã tạo
    ADMIN_SIGNED: 'ADMIN_SIGNED', // Đã ký bởi NĐH
    AGENCY_SIGNED: 'AGENCY_SIGNED', // Đã ký bởi NĐT
    CANCELLED: 'CANCELLED', // Đã hủy
    COMPLETED: 'COMPLETED', // Đã hoàn thành
    EXPIRED: 'EXPIRED', // Đã hết hạn
  },
  // trang thai giao dich rut tien
  AgencyPaymentStatus: {
    REQUESTED: 'REQUESTED', // Đợi xử lý
    PROCESSING: 'PROCESSING', // Đang xử lý
    PAID: 'PAID', // Đã thanh toán
    REJECTED: 'REJECTED', // Từ chối
    FAILED: 'FAILED', // Thất bại
  },
  // hinh thuc phat hanh lo voucher
  VoucherBatchType: {
    SELF_CLAIM: 'SELF-CLAIM', // Tự nhận
    PARTNER: 'PARTNER', // Đối tác
    INTERNAL: 'INTERNAL', // Nội bộ
  },
  // trang thai lo voucher
  VoucherBatchStatus: {
    NEW: 'NEW', // Chưa tạo voucher
    ACTIVE: 'ACTIVE', // Còn hiệu lực
    EXPIRED: 'EXPIRED', // Hết hiệu lực
    DEPLETED: 'DEPLETED', // Đã sử dụng hết
    DELETED: 'DELETED', // Đã xóa
    INACTIVE: 'INACTIVE', // Ngừng hoạt động
  },
  // loai voucher
  VoucherType: {
    MONEY: 'MONEY', // Tiền sạc (VNĐ)
    ENERGY: 'ENERGY', // Điện sạc (kWh)
  },
  // doi tuong nhan voucher
  VoucherIdentityType: {
    DRIVER: 'DRIVER', // Khách hàng
    VEHICLE: 'VEHICLE', // Xe
    ANY: 'ANY', // Chưa xác  định
  },
  // trang thai voucher
  VoucherStatus: {
    NEW: 'NEW', // Đã tạo
    VALID: 'VALID', // Còn hiệu lực
    EXPIRED: 'EXPIRED', // Hết hiệu lực
    INVALID: 'INVALID', // Ngừng hoạt động
  },
};

const AgencyHelper = {
  // MARK: ---- FILTER ----
  Filter: {
    // danh sach don hang
    saleOrderList: {
      page: 0,
      limit: 10,
      q: '',
      status: '',
      orderType: '',
      contractStatus: '',
      primaryRole: '',
      buyerType: '',
      createdBy: '',
      invoiceStatus: '',
      timeFilterType: 'CREATED_DATE',
      dateFilter: dateFilter.tatCaThoiGian,
      from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
      createdDateFilter: dateFilter.tatCaThoiGian,
      createdFrom: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
      createdTo: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    },
    // danh sach hop dong
    contractList: {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      hasAppendices: '',
      contractRole: '',
      contractType: '',
      primaryRole: '',
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    },
    // danh sach mat bang
    premiseOrderList: {
      page: 0,
      limit: 10,
      q: '',
      status: '',
      orderType: '',
      contractStatus: '',
      buyerId: '',
      dateFilter: dateFilter.baMuoiNgayGanNhat,
      from: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.baMuoiNgayGanNhat)[1].format('YYYY-MM-DD'),
    },
    // danh sach xe cua doi tac mua voucher
    voucherPartnerVehicleList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      vehicleType: '',
      brandId: '',
      modelId: '',
    },
    // danh sach lo voucher
    voucherBatchList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      batchType: '',
      identityType: '',
      status: '',
      dateFilter: dateFilter.tatCaThoiGian,
      from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
    },
    // danh sach voucher
    voucherList: {
      q: '',
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      voucherBatchId: '',
      status: '',
      releaseStatus: '',
      releasedDateFilter: dateFilter.tatCaThoiGian,
      releasedFrom: '',
      releasedTo: '',
      expiredDateFilter: dateFilter.tatCaThoiGian,
      expiredFrom: '',
      expiredTo: '',
    },
  },

  // MARK: ---- DATA ----
  Data: {
    orderStatusOptions: [
      { value: AgencyConstants.SaleOrderStatus.ORDERED, name: 'Đã đặt hàng' },
      { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
      { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
      { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
      { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      { value: AgencyConstants.SaleOrderStatus.PAID, name: 'Đã thanh toán' },
      { value: AgencyConstants.SaleOrderStatus.COMPLETED, name: 'Hoàn thành' },
      { value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' },
    ],

    orderTypeOptions: [
      { value: AgencyConstants.SaleOrderType.INVESTOR, name: 'Bán nhượng quyền' },
      { value: AgencyConstants.SaleOrderType.COINVESTOR, name: 'Bán liên kết' },
    ],

    orderStatusOption: {
      ORDERED: [
        { value: AgencyConstants.SaleOrderStatus.ORDERED, name: 'Đã đặt hàng' },
        { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      SHIPPING: [
        { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      INSTALLING: [
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      INSTALLED: [
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      SIGNED: [
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
        { value: AgencyConstants.SaleOrderStatus.PAID, name: 'Đã thanh toán' },
        { value: AgencyConstants.SaleOrderStatus.COMPLETED, name: 'Hoàn thành' },
        { value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' },
      ],
      PAID: [
        { value: AgencyConstants.SaleOrderStatus.PAID, name: 'Đã thanh toán' },
        { value: AgencyConstants.SaleOrderStatus.COMPLETED, name: 'Hoàn thành' },
        { value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' },
      ],
      COMPLETED: [
        { value: AgencyConstants.SaleOrderStatus.COMPLETED, name: 'Hoàn thành' },
        { value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' },
      ],
      CANCELLED: [{ value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' }],
    },

    orderTaxRateOptions: [
      { value: "8", name: '8%' },
      { value: "10", name: '10%' },
      { value: "0", name: 'KCT' },
    ],

    premiseOrderStatusOptions: [
      { value: AgencyConstants.SaleOrderStatus.ORDERED, name: 'Đã đặt hàng' },
      { value: AgencyConstants.SaleOrderStatus.PAID, name: 'Đã duyệt đơn' },
      { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
      { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
      { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
      { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      { value: AgencyConstants.SaleOrderStatus.COMPLETED, name: 'Hoàn thành' },
      { value: AgencyConstants.SaleOrderStatus.CANCELLED, name: 'Đã hủy' },
    ],

    premiseOrderStatusOption: {
      PAID: [
        { value: AgencyConstants.SaleOrderStatus.PAID, name: 'Đã duyệt đơn' },
        { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      SHIPPING: [
        { value: AgencyConstants.SaleOrderStatus.SHIPPING, name: 'Đang vận chuyển' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      INSTALLING: [
        { value: AgencyConstants.SaleOrderStatus.INSTALLING, name: 'Đang lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      INSTALLED: [
        { value: AgencyConstants.SaleOrderStatus.INSTALLED, name: 'Đã lắp đặt' },
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
      SIGNED: [
        { value: AgencyConstants.SaleOrderStatus.SIGNED, name: 'Đã ký biên bản nghiệm thu' },
      ],
    },

    contractOptions: [
      { value: AgencyConstants.ContractStatus.CREATED, name: 'Đã tạo' },
      { value: AgencyConstants.ContractStatus.ADMIN_SIGNED, name: 'Đã ký bởi NĐH' },
      { value: AgencyConstants.ContractStatus.AGENCY_SIGNED, name: 'Đã ký bởi NĐT' },
      { value: AgencyConstants.ContractStatus.COMPLETED, name: 'Hoàn thành' },
      { value: AgencyConstants.ContractStatus.CANCELLED, name: 'Đã hủy' },
      { value: AgencyConstants.ContractStatus.EXPIRED, name: 'Đã hết hạn' },
    ],

    contractOption: {
      CREATED: [
        { value: AgencyConstants.ContractStatus.CREATED, name: 'Đã tạo' },
        { value: AgencyConstants.ContractStatus.ADMIN_SIGNED, name: 'Đã ký bởi NĐH' },
        { value: AgencyConstants.ContractStatus.AGENCY_SIGNED, name: 'Đã ký bởi NĐT' },
        { value: AgencyConstants.ContractStatus.COMPLETED, name: 'Hoàn thành' },
        { value: AgencyConstants.ContractStatus.CANCELLED, name: 'Đã hủy' },
        { value: AgencyConstants.ContractStatus.EXPIRED, name: 'Đã hết hạn' },
      ],
      ADMIN_SIGNED: [
        { value: AgencyConstants.ContractStatus.ADMIN_SIGNED, name: 'Đã ký bởi NĐH' },
        { value: AgencyConstants.ContractStatus.AGENCY_SIGNED, name: 'Đã ký bởi NĐT' },
        { value: AgencyConstants.ContractStatus.COMPLETED, name: 'Hoàn thành' },
        { value: AgencyConstants.ContractStatus.CANCELLED, name: 'Đã hủy' },
        { value: AgencyConstants.ContractStatus.EXPIRED, name: 'Đã hết hạn' },
      ],
      AGENCY_SIGNED: [
        { value: AgencyConstants.ContractStatus.AGENCY_SIGNED, name: 'Đã ký bởi NĐT' },
        { value: AgencyConstants.ContractStatus.COMPLETED, name: 'Hoàn thành' },
      ],
      COMPLETED: [{ value: AgencyConstants.ContractStatus.COMPLETED, name: 'Hoàn thành' }],
      CANCELLED: [{ value: AgencyConstants.ContractStatus.CANCELLED, name: 'Đã hủy' }],
    },

    contractTypeOptions: [
      { value: AgencyConstants.ContractType.DIGITAL, name: 'Hợp đồng điện tử' },
      { value: AgencyConstants.ContractType.PAPER, name: 'Hợp đồng giấy' },
    ],
    acceptanceTypeOptions: [
      { value: AgencyConstants.ContractType.DIGITAL, name: 'Biên bản điện tử' },
      { value: AgencyConstants.ContractType.PAPER, name: 'Biên bản giấy' },
    ],
    appendixTypeOptions: [
      { value: AgencyConstants.AppendixType.DIGITAL, name: 'Phụ lục điện tử' },
      { value: AgencyConstants.AppendixType.PAPER, name: 'Phụ lục giấy' },
    ],

    reconciliationStatusOptions: [
      { value: AgencyConstants.AgencyReconciliationStatus.CREATED, name: 'Đã tạo' },
      { value: AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED, name: 'Đã ký bởi NĐH' },
      {
        value: AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED,
        name: 'Đã ký bởi đối tác',
      },
    ],
    reconciliationRoleOptions: [
      {
        value: AgencyConstants.AgencyReconciliationRole.SALE,
        name: 'Đối soát với đại lý bán hàng',
      },
      {
        value: AgencyConstants.AgencyReconciliationRole.INVESTOR,
        name: 'Đối soát với nhà đầu tư NQ',
      },
      {
        value: AgencyConstants.AgencyReconciliationRole.COINVESTOR,
        name: 'Đối soát với nhà đầu tư liên kết',
      },
      {
        value: AgencyConstants.AgencyReconciliationRole.GROUP,
        name: 'Đối soát với NĐT liên kết',
      },
    ],
    // mat bang
    rentingTypeOptions: [
      { value: AgencyConstants.RentingType.FULL, name: 'Toàn bộ mặt bằng' },
      { value: AgencyConstants.RentingType.SLOT, name: 'Theo số chỗ đỗ xe' },
    ],
    premiseStatusOptions: [
      { value: AgencyConstants.PremiseStatus.AVAILABLE, name: 'Chưa thuê' },
      { value: AgencyConstants.PremiseStatus.RENTED, name: 'Đã thuê' },
      { value: AgencyConstants.PremiseStatus.DELETED, name: 'Đã bị xóa' },
    ],
    premiseContractStatusOptions: [
      { value: AgencyConstants.PremiseContractStatus.CREATED, name: 'Đã tạo' },
      { value: AgencyConstants.PremiseContractStatus.ADMIN_SIGNED, name: 'Đã ký bởi NĐH' },
      { value: AgencyConstants.PremiseContractStatus.LANDLORD_SIGNED, name: 'Đã ký bởi chủ MB' },
      { value: AgencyConstants.PremiseContractStatus.CANCELLED, name: 'Đã hủy' },
      { value: AgencyConstants.PremiseContractStatus.COMPLETED, name: 'Hoàn thành' },
    ],
    // loai doi tac mua tru sac
    partnerTypeOptions: [
      {
        value: AgencyConstants.AgencyRole.CHARGEPOINT,
        name: 'Đối tác thông thường',
      },
      {
        value: AgencyConstants.AgencyRole.GROUP,
        name: 'NĐT liên kết',
      },
      {
        value: AgencyConstants.AgencyRole.INVESTOR,
        name: 'Nhà đầu tư nhượng quyền',
      },
      {
        value: AgencyConstants.AgencyRole.COINVESTOR,
        name: 'Nhà đầu tư liên kết',
      },
      {
        value: AgencyConstants.AgencyRole.LANDLORD,
        name: 'Chủ mặt bằng',
      },
    ],
    // mo hinh chia se doanh thu
    energyCommissionModeOptions: [
      {
        value: AgencyConstants.EnergyCommissionMode.FIXED_PER_KWH,
        name: 'Hoa hồng cố định theo số điện',
      },
      {
        value: AgencyConstants.EnergyCommissionMode.PERCENT_INPUT,
        name: 'Hoa hồng tỉ lệ theo giá điện mua của nhà nước',
      },
      {
        value: AgencyConstants.EnergyCommissionMode.PERCENT_OUTPUT,
        name: 'Hoa hồng tỉ lệ theo giá điện bán ra',
      },
      {
        value: AgencyConstants.EnergyCommissionMode.PERCENT_PROFIT,
        name: 'Hoa hồng tỷ lệ theo lợi nhuận',
      },
      {
        value: AgencyConstants.EnergyCommissionMode.FIXED_PER_MONTH,
        name: 'Cố định theo tháng',
      },
      {
        value: AgencyConstants.EnergyCommissionMode.FIXED_PER_KWH_PER_VEHICLE_TYPE,
        name: 'Doanh thu cố định theo kW điện bán ra',
      },
    ],
    // mau hop dong
    contractRoleOptions: [
      {
        value: AgencyConstants.ContractRole.SALE,
        name: 'Hợp đồng cộng tác viên',
      },
      {
        value: AgencyConstants.ContractRole.INVESTOR,
        name: 'Hợp đồng bán nhượng quyền',
      },
      {
        value: AgencyConstants.ContractRole.COINVESTOR,
        name: 'Hợp đồng bán liên kết',
      },
      {
        value: AgencyConstants.ContractRole.GROUP,
        name: 'Hợp đồng hợp tác kinh doanh',
      },
      {
        value: AgencyConstants.ContractRole.LANDLORD,
        name: 'Hợp đồng hợp tác mặt bằng',
      },
      {
        value: AgencyConstants.ContractRole.CHARGEPOINT,
        name: 'Hợp đồng bán trụ sạc',
      },
      {
        value: AgencyConstants.ContractRole.FRANCHISE,
        name: 'Hợp đồng nhượng quyền',
      },
      {
        value: AgencyConstants.ContractRole.INVESTOR,
        name: 'Hợp đồng mua bán',
      },
      {
        value: AgencyConstants.ContractRole.GROUP,
        name: 'Hợp đồng liên kết',
      },
    ],
    // loai dai ly
    agencyRoleOptions: [
      {
        value: AgencyConstants.AgencyRole.SALE,
        name: 'Đại lý',
      },
      {
        value: AgencyConstants.AgencyRole.INVESTOR,
        name: 'NĐT nhượng quyền',
      },
      {
        value: AgencyConstants.AgencyRole.COINVESTOR,
        name: 'Nhà đầu tư liên kết',
      },
      {
        value: AgencyConstants.AgencyRole.GROUP,
        name: 'NĐT liên kết',
      },
    ],
    // trang thai phu luc
    appendixOptions: [
      { value: '1', name: 'Đã có phụ lục' },
      { value: '0', name: 'Chưa có phụ lục' },
    ],

    // hinh thuc phat hanh lo voucher
    voucherBatchTypeOptions: [
      { value: AgencyConstants.VoucherBatchType.SELF_CLAIM, name: 'Tự nhận' },
      { value: AgencyConstants.VoucherBatchType.PARTNER, name: 'Đối tác' },
      { value: AgencyConstants.VoucherBatchType.INTERNAL, name: 'Nội bộ' },
    ],
    // hinh thuc phat hanh khi them lo voucher
    voucherAddBatchTypeOptions: [
      { value: AgencyConstants.VoucherBatchType.SELF_CLAIM, name: 'Tự nhận (Khách hàng tự nhận voucher từ kho công khai)' },
      { value: AgencyConstants.VoucherBatchType.PARTNER, name: 'Đối tác (Đối tác phân phối hoặc gán voucher cho khách hàng/xe)' },
      { value: AgencyConstants.VoucherBatchType.INTERNAL, name: 'Nội bộ (Nhà điều hành gán voucher trực tiếp, không công khai)' },
    ],
    // doi tuong nhan voucher
    voucherIdentityTypeOptions: [
      { value: AgencyConstants.VoucherIdentityType.DRIVER, name: 'Khách hàng' },
      { value: AgencyConstants.VoucherIdentityType.VEHICLE, name: 'Xe' },
      { value: AgencyConstants.VoucherIdentityType.ANY, name: 'Chưa xác định' },
    ],
    // doi tuong nhan voucher cho doi tac
    agencyVoucherIdentityTypeOptions: [
      { value: AgencyConstants.VoucherIdentityType.DRIVER, name: 'Khách hàng' },
      { value: AgencyConstants.VoucherIdentityType.VEHICLE, name: 'Xe' },
    ],
    // trang thai lo voucher
    voucherBatchStatusOptions: [
      { value: AgencyConstants.VoucherBatchStatus.NEW, name: 'Chưa tạo voucher' },
      { value: AgencyConstants.VoucherBatchStatus.ACTIVE, name: 'Còn hiệu lực' },
      { value: AgencyConstants.VoucherBatchStatus.EXPIRED, name: 'Hết hiệu lực' },
      { value: AgencyConstants.VoucherBatchStatus.DEPLETED, name: 'Đã sử dụng hết' },
      { value: AgencyConstants.VoucherBatchStatus.DELETED, name: 'Đã xóa' },
      { value: AgencyConstants.VoucherBatchStatus.INACTIVE, name: 'Ngừng hoạt động' },
    ],
    // loai voucher
    voucherTypeOptions: [
      { value: AgencyConstants.VoucherType.MONEY, name: 'Tiền sạc (VNĐ)' },
      { value: AgencyConstants.VoucherType.ENERGY, name: 'Điện sạc (kWh)' },
    ],

    // trang thai voucher
    voucherStatusOptions: [
      { value: AgencyConstants.VoucherStatus.NEW, name: 'Đã tạo' },
      { value: AgencyConstants.VoucherStatus.VALID, name: 'Còn hiệu lực' },
      { value: AgencyConstants.VoucherStatus.EXPIRED, name: 'Hết hiệu lực' },
      { value: AgencyConstants.VoucherStatus.INVALID, name: 'Ngừng hoạt động' },
    ],

    // danh sach cac quoc gia
    CountryOptions: [
      { name: 'Việt Nam', value: 'VN' },
      { name: 'Afghanistan', value: 'AF' },
      { name: 'Albani', value: 'AL' },
      { name: 'Algérie', value: 'DZ' },
      { name: 'Argentina', value: 'AR' },
      { name: 'Armenia', value: 'AM' },
      { name: 'Úc', value: 'AU' },
      { name: 'Áo', value: 'AT' },
      { name: 'Azerbaijan', value: 'AZ' },
      { name: 'Bangladesh', value: 'BD' },
      { name: 'Bỉ', value: 'BE' },
      { name: 'Bolivia', value: 'BO' },
      { name: 'Brazil', value: 'BR' },
      { name: 'Bulgaria', value: 'BG' },
      { name: 'Campuchia', value: 'KH' },
      { name: 'Canada', value: 'CA' },
      { name: 'Chile', value: 'CL' },
      { name: 'Trung Quốc', value: 'CN' },
      { name: 'Colombia', value: 'CO' },
      { name: 'Costa Rica', value: 'CR' },
      { name: 'Croatia', value: 'HR' },
      { name: 'Séc', value: 'CZ' },
      { name: 'Đan Mạch', value: 'DK' },
      { name: 'Ai Cập', value: 'EG' },
      { name: 'Estonia', value: 'EE' },
      { name: 'Phần Lan', value: 'FI' },
      { name: 'Pháp', value: 'FR' },
      { name: 'Georgia', value: 'GE' },
      { name: 'Đức', value: 'DE' },
      { name: 'Hy Lạp', value: 'GR' },
      { name: 'Guatemala', value: 'GT' },
      { name: 'Hồng Kông', value: 'HK' },
      { name: 'Hungary', value: 'HU' },
      { name: 'Iceland', value: 'IS' },
      { name: 'Ấn Độ', value: 'IN' },
      { name: 'Indonesia', value: 'ID' },
      { name: 'Iran', value: 'IR' },
      { name: 'Iraq', value: 'IQ' },
      { name: 'Ireland', value: 'IE' },
      { name: 'Israel', value: 'IL' },
      { name: 'Ý', value: 'IT' },
      { name: 'Nhật Bản', value: 'JP' },
      { name: 'Jordan', value: 'JO' },
      { name: 'Kazakhstan', value: 'KZ' },
      { name: 'Kenya', value: 'KE' },
      { name: 'Hàn Quốc', value: 'KR' },
      { name: 'Kuwait', value: 'KW' },
      { name: 'Lào', value: 'LA' },
      { name: 'Latvia', value: 'LV' },
      { name: 'Liban', value: 'LB' },
      { name: 'Litva', value: 'LT' },
      { name: 'Luxembourg', value: 'LU' },
      { name: 'Malaysia', value: 'MY' },
      { name: 'Mexico', value: 'MX' },
      { name: 'Mông Cổ', value: 'MN' },
      { name: 'Ma-rốc', value: 'MA' },
      { name: 'Myanmar', value: 'MM' },
      { name: 'Nepal', value: 'NP' },
      { name: 'Hà Lan', value: 'NL' },
      { name: 'New Zealand', value: 'NZ' },
      { name: 'Nigeria', value: 'NG' },
      { name: 'Na Uy', value: 'NO' },
      { name: 'Pakistan', value: 'PK' },
      { name: 'Panama', value: 'PA' },
      { name: 'Peru', value: 'PE' },
      { name: 'Philippines', value: 'PH' },
      { name: 'Ba Lan', value: 'PL' },
      { name: 'Bồ Đào Nha', value: 'PT' },
      { name: 'Qatar', value: 'QA' },
      { name: 'Romania', value: 'RO' },
      { name: 'Nga', value: 'RU' },
      { name: 'Ả Rập Xê Út', value: 'SA' },
      { name: 'Singapore', value: 'SG' },
      { name: 'Slovakia', value: 'SK' },
      { name: 'Slovenia', value: 'SI' },
      { name: 'Nam Phi', value: 'ZA' },
      { name: 'Tây Ban Nha', value: 'ES' },
      { name: 'Sri Lanka', value: 'LK' },
      { name: 'Thụy Điển', value: 'SE' },
      { name: 'Thụy Sĩ', value: 'CH' },
      { name: 'Đài Loan', value: 'TW' },
      { name: 'Thái Lan', value: 'TH' },
      { name: 'Thổ Nhĩ Kỳ', value: 'TR' },
      { name: 'Ukraina', value: 'UA' },
      { name: 'Các Tiểu vương quốc Ả Rập Thống nhất', value: 'AE' },
      { name: 'Vương quốc Anh', value: 'GB' },
      { name: 'Hoa Kỳ', value: 'US' },
      { name: 'Uruguay', value: 'UY' },
      { name: 'Uzbekistan', value: 'UZ' },
      { name: 'Venezuela', value: 'VE' },
      { name: 'Yemen', value: 'YE' }
    ],
  },

  // MARK: ---- API ----
  API: {
    // ---- AGENCY ----
    // lay ds agency
    requestGetAgencyList: async (params) => {
      const url = '/agency';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, agencies, total } = response;
        if (result === 'success') {
          return { agencies, total };
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // tim kiem agency
    requestSearchAgency: async (params) => {
      const url = '/sale/searchAgency';
      try {
        const response = await axiosClient.post(url, params);
        const { result, agencies, total } = response;
        if (result === 'success') {
          return { agencies, total };
        }
        return { agencies: [], total: 0 };
      } catch (error) {
        return { agencies: [], total: 0 };
      }
    },

    // lay thong tin chi tiet agency
    requestAgencyDetail: async (agencyId) => {
      const url = `/agency/${agencyId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, agency } = response;
        if (result === 'success') {
          return agency;
        }
        return null;
      } catch (error) {
        return null;
      }
    },

    // ---- ĐƠN HÀNG ----
    // lay ds don hang cua toi
    requestGetMySaleList: async (params) => {
      const url = '/agency/order/my';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, orders, total } = response;
        if (result === 'success') {
          return { orders, total };
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // lay ds don hang
    requestGetSaleList: async (params) => {
      const url = '/sale';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, sales, total } = response;
        if (result === 'success') {
          return { sales, total };
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // lay chi tiet don hang
    requestGetSaleDetail: async (saleId) => {
      const url = `/sale/${saleId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, sale } = response;
        if (result === 'success') {
          return sale;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // cap nhat don hang
    requestUpdateSale: async (saleId, params) => {
      const url = `/sale/${saleId}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return false;
      }
    },
    // tao don hang
    requestCreateSale: async (params) => {
      const url = '/sale/create';
      try {
        const response = await axiosClient.post(url, params);
        const { result, sale } = response;
        if (result === 'success') {
          return sale;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // xoa don hang
    requestDeleteSale: async (saleId) => {
      const url = `/sale/${saleId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || false;
      }
    },
    // tao investment
    requestCreateInvestment: async (params) => {
      const url = '/investment/create';
      try {
        const response = await axiosClient.post(url, params);
        const { result, investment } = response;
        if (result === 'success') {
          return investment;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // cap nhat investment
    requestUpdateInvestment: async (id, params) => {
      const url = `/investment/${id}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result, investment } = response;
        if (result === 'success') {
          return investment;
        }
        return null;
      } catch (error) {
        return null;
      }
    },

    // ---- HỢP ĐỒNG ----
    // tao hop dong cho don hang ban goi dau tu HTKD
    requestCreateGroupContract: async (params) => {
      const url = '/contract/createGroupContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong cho don hang nhuong quyen
    requestCreateInvestorContract: async (params) => {
      const url = '/contract/createInvestorContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong cho don hang lien ket
    requestCreateCoinvestorContract: async (params) => {
      const url = '/contract/createCoinvestorContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong cho don hang gioi thieu mat bang
    requestCreateLandlordContract: async (params) => {
      const url = '/contract/createLandlordContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong cho don hang ban tru sac
    requestCreateChargePointContract: async (params) => {
      const url = '/contract/createChargePointContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong cho SALE
    requestCreateSaleContract: async (params) => {
      const url = '/contract/createSaleContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // lay ds hop dong
    requestGetContractList: async (params) => {
      const url = '/contract/all';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, contracts } = response;
        if (result === 'success') {
          return contracts;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // lay ds hop dong cua agency
    requestGetAgencyContractList: async (params) => {
      const url = 'agency/contract/all';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, contracts, total } = response;
        if (result === 'success') {
          return { contracts, total };
        }
        return { contracts: [], total: 0 };
      } catch (error) {
        return { contracts: [], total: 0 };
      }
    },
    // poa ky hop dong
    requestPoaSignContract: async (contractIds, hsmPassword) => {
      const url = `/contract/authorizedPersonSignPOA/`;
      try {
        const response = await axiosClient.post(url, {
          contractId: contractIds,
          hsmPassword,
        });
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return false;
      }
    },
    // admin ky hop dong
    requestAdminSignContract: async (contractId) => {
      const url = `/contract/adminSignContract/${contractId}`;
      try {
        const response = await axiosClient.post(url);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // agency ky hop dong
    requestAgencySignContract: async (contractId, hsmAgreementUUID, hsmPassword) => {
      const url = `/contract/agencySignContract/${contractId}`;
      try {
        const response = await axiosClient.post(url, { hsmAgreementUUID, hsmPassword });
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // xoa hop dong
    requestDeleteContract: async (contractId) => {
      const url = `/contract/deleteContract/${contractId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || false;
      }
    },
    // cap nhat hop dong
    requestUpdateContract: async (contractId, params) => {
      const url = `/contract/updateContract/${contractId}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // sinh so hop dong
    requestGenerateContractNumber: async (params) => {
      const url = '/contract/generateContractNumber';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contractNumber } = response;
        if (result === 'success') {
          return contractNumber;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao hop dong nhuong quyen
    requestCreateFranchiseContract: async (params) => {
      const url = '/contract/createFranchiseContract';
      try {
        const response = await axiosClient.post(url, params);
        const { result, contract } = response;
        if (result === 'success') {
          return contract;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // ky bat cu tai lieu nao
    requestSignDocument: async (params) => {
      const path = `/contract/signPDF`;
      try {
        const response = await axiosClient.post(path, params);
        const { result, url, file } = response;
        if (result === 'success') {
          return { url, file };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // upload file hop dong giay
    requestUploadPaperContract: async (file) => {
      const path = `/media/uploadContract`;
      try {
        const formData = new FormData();
        formData.append('file', file);
        const { result, media } = await axiosClient.post(path, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (result === 'success' && media) {
          return media;
        }
        return [];
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },

    // ---- ĐỐI SOÁT ----
    // lay ds doi soat
    requestGetReconciliationList: async (params) => {
      const url = '/reconciliation/list';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, reconciliations, total } = response;
        if (result === 'success') {
          return { reconciliations, total };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // lay chi tiet doi soat
    requestGetReconciliationDetail: async (reconciliationId) => {
      const url = `/reconciliation/detail?reconciliationId=${reconciliationId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, reconciliation } = response;
        if (result === 'success') {
          return reconciliation;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao doi soat HTKD
    requestCreateGroupReconciliation: async (params) => {
      const url = '/reconciliation/createGroupReconciliation';
      try {
        const response = await axiosClient.post(url, params);
        const { result, reconciliations } = response;
        if (result === 'success') {
          return reconciliations;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao doi soat dai ly ban hang
    requestCreateReconciliation: async (params) => {
      const url = '/reconciliation/create';
      try {
        const response = await axiosClient.post(url, params);
        const { result, reconciliation } = response;
        if (result === 'success') {
          return reconciliation;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // cap nhat doi soat
    requestUpdateReconciliation: async (reconciliationId, params) => {
      const url = `/reconciliation/${reconciliationId}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result, reconciliation } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // upload doi soat giay
    requestUploadPaperReconciliation: async (params) => {
      const url = `/reconciliation/upload`;
      try {
        const response = await axiosClient.post(url, params);
        const { result, reconciliation } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // xoa doi soat
    requestDeleteReconciliation: async (reconciliationId) => {
      const url = `/reconciliation/${reconciliationId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || false;
      }
    },
    // gui phan hoi doi soat
    requestCreateFeedbackReconciliation: async (params) => {
      const url = '/reconciliation/feedback';
      try {
        const response = await axiosClient.post(url, params);
        const { result } = response;
        return result === 'success'
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // upload hoa don thue
    requestUploadInvoiceDocument: async (params) => {
      const url = `/reconciliation/uploadInvoice`;
      try {
        const response = await axiosClient.post(url, params);
        const { result, reconciliation } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // lay ds tai khoan ngan hang cua agency
    requestGetAgencyBankAccountList: async (agencyId) => {
      const url = `/agency/bankAccount/all?agencyId=${agencyId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, bankAccounts, total } = response;
        if (result === 'success') {
          return { bankAccounts, total };
        }
        return { bankAccounts: [], total: 0 };
      } catch (error) {
        return { bankAccounts: [], total: 0 };
      }
    },
    requestGetAgencySaleReport: async (params) => {
      const url = '/agency/sale/report';
      try {
        const response = await axiosClient.get(url, { params });
        const { result } = response;
        if (result === 'success') {
          return response;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    requestGetAgencyMonthlySale: async (params) => {
      const url = '/sale/getMonthlySale';
      try {
        const response = await axiosClient.post(url, params);
        const { result, revenue, referral } = response;
        if (result === 'success') {
          return {
            [AgencyConstants.AgencyRole.GROUP]:
              _.find(revenue, (item) => item.orderType === AgencyConstants.SaleOrderType.GROUP) ?? {},
            [AgencyConstants.AgencyRole.SALE]:
              _.find(revenue, (item) => item.orderType === AgencyConstants.SaleOrderType.SALE) ?? {},
            [AgencyConstants.AgencyRole.INVESTOR]:
              _.find(revenue, (item) => item.orderType === AgencyConstants.SaleOrderType.INVESTOR) ?? {},
            [AgencyConstants.AgencyRole.COINVESTOR]:
              _.find(revenue, (item) => item.orderType === AgencyConstants.SaleOrderType.COINVESTOR) ?? {},
            [AgencyConstants.AgencyRole.LANDLORD]:
              _.find(referral, (item) => item.orderType === AgencyConstants.SaleOrderType.LANDLORD) ?? {},
            [AgencyConstants.AgencyRole.CHARGEPOINT]:
              _.find(revenue, (item) => item.orderType === AgencyConstants.SaleOrderType.CHARGEPOINT) ?? {},
          };
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    requestGetMonthlySaleCommission: async (params) => {
      const url = '/dashboard/getMonthlySaleCommission';
      try {
        const response = await axiosClient.get(url, { params });
        const { result } = response;
        if (result === 'success') {
          return response;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    requestGetInvestorSummary: async (agencyId) => {
      const url = `/dashboard/investorSummary?agencyId=${agencyId}`;
      try {
        const response = await axiosClient.get(url);
        const { result } = response;
        if (result === 'success') {
          return response;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    requestGetInvestmentReport: async (params) => {
      const url = '/investment/report';
      try {
        const response = await axiosClient.get(url, { params });
        const { result } = response;
        if (result === 'success') {
          return response;
        }
        return null;
      } catch (error) {
        return null;
      }
    },
    // agency ky doi soat
    requestAgencySignReconciliation: async (params) => {
      const url = '/reconciliation/agencySign';
      try {
        const response = await axiosClient.post(url, params);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // admin ky doi soat
    requestAdminSignReconciliation: async (params) => {
      const url = '/reconciliation/adminSign';
      try {
        const response = await axiosClient.post(url, params);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // ---- MẶT BẰNG ----
    // lay ds mat bang
    requestGetPremiseList: async (params) => {
      const url = '/premise';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, premises, total } = response;
        if (result === 'success') {
          return { premises, total };
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // lay chi tiet mat bang
    requestGetPremiseDetail: async (premiseId) => {
      const url = `/premise/${premiseId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, premise } = response;
        if (result === 'success') {
          return premise;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao mat bang
    requestCreatePremise: async (params) => {
      const url = '/premise/create';
      try {
        const response = await axiosClient.post(url, params);
        const { result, premise } = response;
        if (result === 'success') {
          return premise;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // cap nhat mat bang
    requestUpdatePremise: async (premiseId, params) => {
      const url = `/premise/${premiseId}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // xoa mat bang
    requestDeletePremise: async (premiseId) => {
      const url = `/premise/${premiseId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || false;
      }
    },
    // tao lenh rut tien
    requestAgencyWithdraw: async (params) => {
      const url = '/agency/withdraw';
      try {
        const response = await axiosClient.post(url, params);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // ---- BIÊN BẢN NGHIỆM THU ----
    // sinh so bien ban nghiem thu
    requestGenerateAcceptanceNumber: async (params) => {
      const url = '/acceptance/generateNumber';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, number } = response;
        if (result === 'success') {
          return number;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao bien ban nghiem thu
    requestCreateAcceptanceReport: async (params) => {
      const url = '/acceptance/create';
      try {
        const response = await axiosClient.post(url, params);
        const { result, acceptanceReport } = response;
        if (result === 'success') {
          return acceptanceReport;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // cap nhat bien ban nghiem thu
    requestUpdateAcceptanceReport: async (acceptanceId, params) => {
      const url = `/acceptance/${acceptanceId}`;
      try {
        const response = await axiosClient.put(url, params);
        const { result, acceptanceId } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // xoa bien ban nghiem thu
    requestDeleteAcceptanceReport: async (acceptanceId) => {
      const url = `/acceptance/${acceptanceId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || false;
      }
    },
    // ktv ky bien ban ky thuat
    requestAdminSignTechnicalAcceptance: async (params) => {
      const url = `/acceptance/technicianSign`;
      try {
        const response = await axiosClient.post(url, params);
        const { result, acceptanceReport } = response;
        if (result === 'success') {
          return acceptanceReport;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // admin ky bien ban thanh toan
    requestAdminSignFinancialAcceptance: async (params) => {
      const url = `/acceptance/adminSign`;
      try {
        const response = await axiosClient.post(url, params);
        const { result, acceptanceReport } = response;
        if (result === 'success') {
          return acceptanceReport;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // agency ky bien ban
    requestAgencySignAcceptance: async (params) => {
      const url = `/acceptance/agencySign`;
      try {
        const response = await axiosClient.post(url, params);
        const { result, acceptanceReport } = response;
        if (result === 'success') {
          return acceptanceReport;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // lay danh sach xe cua doi tac mua voucher
    requestGetVoucherPartnerVehicleList: async (params = {}) => {
      const url = '/partner/vehicle';
      try {
        const response = await axiosClient.get(url, { params });
        const { result, vehicles, total } = response;
        if (result === 'success') {
          return { vehicles, total };
        }
        return { vehicles: [], total: 0 };
      } catch (error) {
        return { vehicles: [], total: 0 };
      }
    },
    // them xe doi tac mua voucher
    requestAddVoucherPartnerVehicle: async (data) => {
      const url = '/partner/vehicle';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm xe thất bại';
      }
    },
    // cap nhat xe doi tac mua voucher
    requestUpdateVoucherPartnerVehicle: async (vehicleId, data) => {
      const url = `/partner/vehicle/${vehicleId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật xe thất bại';
      }
    },
    // xoa xe doi tac mua voucher
    requestDeleteVoucherPartnerVehicle: async (vehicleId) => {
      const url = `/partner/vehicle/${vehicleId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa xe thất bại';
      }
    },
    // lay danh sach lo voucher
    isRequestCancelled,
    requestGetVoucherBatchList: async (params = {}, axiosConfig = {}) => {
      const url = '/voucherBatch';
      try {
        const response = await axiosClient.get(url, { params, ...axiosConfig });
        const { result, voucherBatches, total } = response;
        if (result === 'success') {
          return { voucherBatches, total };
        }
        return { voucherBatches: [], total: 0 };
      } catch (error) {
        if (isRequestCancelled(error)) {
          throw error;
        }
        return { voucherBatches: [], total: 0 };
      }
    },
    // lay chi tiet lo voucher
    requestGetVoucherBatchDetail: async (voucherBatchId) => {
      const url = `/voucherBatch/${voucherBatchId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, voucherBatch } = response;
        if (result === 'success') {
          return voucherBatch;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // tao lo voucher
    requestAddVoucherBatch: async (data) => {
      const url = '/voucherBatch/create';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Thêm lô voucher thất bại';
      }
    },
    // cap nhat lo voucher
    requestUpdateVoucherBatch: async (voucherBatchId, data) => {
      const url = `/voucherBatch/${voucherBatchId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật lô voucher thất bại';
      }
    },
    // phat hanh lo voucher
    requestReleaseVoucherBatch: async (data) => {
      const url = '/voucherBatch/release';
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Phát hành lô voucher thất bại';
      }
    },
    // xoa xe lo voucher
    requestDeleteVoucherBatch: async (voucherBatchId) => {
      const url = `/voucherBatch/${voucherBatchId}`;
      try {
        const response = await axiosClient.delete(url);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Xóa lô voucher thất bại';
      }
    },
    // lay danh sach voucher
    requestGetVoucherList: async (params = {}, axiosConfig = {}) => {
      const url = '/voucher';
      try {
        const response = await axiosClient.get(url, { params, ...axiosConfig });
        const { result, vouchers, total } = response;
        if (result === 'success') {
          return { vouchers, total };
        }
        return { vouchers: [], total: 0 };
      } catch (error) {
        if (isRequestCancelled(error)) {
          throw error;
        }
        return { vouchers: [], total: 0 };
      }
    },
    // lay chi tiet voucher
    requestGetVoucherDetail: async (voucherId) => {
      const url = `/voucher/${voucherId}`;
      try {
        const response = await axiosClient.get(url);
        const { result, voucher } = response;
        if (result === 'success') {
          return voucher;
        }
        return null;
      } catch (error) {
        return error?.response?.data?.reason || null;
      }
    },
    // cap nhat voucher
    requestUpdateVoucher: async (voucherId, data) => {
      const url = `/voucher/${voucherId}`;
      try {
        const response = await axiosClient.put(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Cập nhật voucher thất bại';
      }
    },
    // phat hanh hang loat voucher
    requestReleaseListVoucher: async (data) => {
      const url = `/voucher/release`;
      try {
        const response = await axiosClient.post(url, data);
        const { result } = response;
        return result === 'success';
      } catch (error) {
        return error?.response?.data?.reason || 'Phát hành voucher thất bại';
      }
    },
    // tong quan
    requestGetVoucherPartnerDashboard: async (params) => {
      const url = `/dashboard/voucherSummary`;
      try {
        const response = await axiosClient.get(url, { params });
        const { result } = response;
        if (result === 'success') {
          return response;
        }
      } catch (error) {
        return error?.response?.data?.reason;
      }
    },
  },


  // MARK: ---- UTILS ----
  Utils: {
    // kiem tra don hang co the chinh sua
    checkSaleOrderCanEdit: (status) => {
      return ![
        AgencyConstants.SaleOrderStatus.COMPLETED,
        AgencyConstants.SaleOrderStatus.CANCELLED,
        AgencyConstants.SaleOrderStatus.SIGNED,
        AgencyConstants.SaleOrderStatus.PAID,
      ].includes(status);
    },
    // kiem tra don mat bang co the chinh sua
    checkPremiseOrderCanEdit: (contractStatus) => {
      return [AgencyConstants.ContractStatus?.AGENCY_SIGNED].includes(contractStatus);
    },
    // ten loai don hang
    getSaleOrderTypeName: (orderType) => {
      switch (orderType) {
        case AgencyConstants.SaleOrderType.INVESTOR:
          return 'Bán nhượng quyền';
        case AgencyConstants.SaleOrderType.COINVESTOR:
          return 'Bán liên kết';
        case AgencyConstants.SaleOrderType.GROUP:
          return 'Bán gói đầu tư HTKD';
        case AgencyConstants.SaleOrderType.LANDLORD:
          return 'Giới thiệu mặt bằng';
        case AgencyConstants.SaleOrderType.CHARGEPOINT:
          return 'Bán trụ sạc';
        default:
          return '';
      }
    },
    // ten trang thai don hang
    getSaleOrderStatusName: (orderStatus, orderType) => {
      if (
        orderStatus === AgencyConstants.SaleOrderStatus.PAID &&
        orderType === AgencyConstants.SaleOrderType.LANDLORD
      ) {
        return 'Đã duyệt đơn';
      }

      switch (orderStatus) {
        case AgencyConstants.SaleOrderStatus.ORDERED:
          return 'Đã đặt hàng';
        case AgencyConstants.SaleOrderStatus.SHIPPING:
          return 'Đang vận chuyển';
        case AgencyConstants.SaleOrderStatus.INSTALLING:
          return 'Đang lắp đặt';
        case AgencyConstants.SaleOrderStatus.INSTALLED:
          return 'Đã lắp đặt';
        case AgencyConstants.SaleOrderStatus.SIGNED:
          return 'Đã ký biên bản nghiệm thu';
        case AgencyConstants.SaleOrderStatus.PAID:
          return 'Đã thanh toán';
        case AgencyConstants.SaleOrderStatus.COMPLETED:
          return 'Hoàn thành';
        case AgencyConstants.SaleOrderStatus.CANCELLED:
          return 'Đã hủy';
        default:
          return '';
      }
    },
    // mau sac trang thai don hang
    getSaleOrderStatusColor: (orderStatus) => {
      switch (orderStatus) {
        case AgencyConstants.SaleOrderStatus.ORDERED:
          return 'primary';
        case AgencyConstants.SaleOrderStatus.SHIPPING:
          return 'warning';
        case AgencyConstants.SaleOrderStatus.INSTALLING:
          return 'warning';
        case AgencyConstants.SaleOrderStatus.INSTALLED:
          return 'warning';
        case AgencyConstants.SaleOrderStatus.SIGNED:
          return 'warning';
        case AgencyConstants.SaleOrderStatus.PAID:
          return 'info';
        case AgencyConstants.SaleOrderStatus.COMPLETED:
          return 'success';
        case AgencyConstants.SaleOrderStatus.CANCELLED:
          return 'danger';
        default:
          return '';
      }
    },
    // ten trang thai hop dong
    getContractStatusName: (contractStatus) => {
      switch (contractStatus) {
        case AgencyConstants.ContractStatus.CREATED:
          return 'Đã tạo';
        case AgencyConstants.ContractStatus.ADMIN_SIGNED:
          return 'Đã ký bởi NĐH';
        case AgencyConstants.ContractStatus.AGENCY_SIGNED:
          return 'Đã ký bởi NĐT';
        case AgencyConstants.ContractStatus.CANCELLED:
          return 'Đã hủy';
        case AgencyConstants.ContractStatus.COMPLETED:
          return 'Hoàn thành';
        case AgencyConstants.ContractStatus.EXPIRED:
          return 'Đã hết hạn';
        default:
          return '';
      }
    },
    // mau sac trang thai hop dong
    getContractStatusColor: (contractStatus) => {
      switch (contractStatus) {
        case AgencyConstants.ContractStatus.CREATED:
          return 'primary';
        case AgencyConstants.ContractStatus.ADMIN_SIGNED:
          return 'warning';
        case AgencyConstants.ContractStatus.AGENCY_SIGNED:
          return 'warning';
        case AgencyConstants.ContractStatus.CANCELLED:
          return 'danger';
        case AgencyConstants.ContractStatus.COMPLETED:
          return 'success';
        case AgencyConstants.ContractStatus.EXPIRED:
          return 'danger';
        default:
          return '';
      }
    },
    // ten trang thai bien ban
    getAcceptanceStatusName: (acceptanceStatus, acceptanceRole) => {
      switch (acceptanceStatus) {
        case AgencyConstants.AcceptanceStatus.CREATED:
          return 'Đã tạo';
        case AgencyConstants.AcceptanceStatus.ADMIN_SIGNED:
          return acceptanceRole === AgencyConstants.AcceptanceRole.TECHNICAL
            ? 'Đã ký bởi KTV'
            : 'Đã ký bởi NĐH';
        case AgencyConstants.AcceptanceStatus.AGENCY_SIGNED:
          return 'Đã ký bởi NĐT';
        case AgencyConstants.AcceptanceStatus.CANCELLED:
          return 'Đã hủy';
        case AgencyConstants.AcceptanceStatus.COMPLETED:
          return 'Hoàn thành';
        case AgencyConstants.AcceptanceStatus.EXPIRED:
          return 'Đã hết hạn';
        default:
          return '';
      }
    },
    // mau sac trang thai bien ban
    getAcceptanceStatusColor: (acceptanceStatus) => {
      switch (acceptanceStatus) {
        case AgencyConstants.AcceptanceStatus.CREATED:
          return 'primary';
        case AgencyConstants.AcceptanceStatus.ADMIN_SIGNED:
          return 'warning';
        case AgencyConstants.AcceptanceStatus.AGENCY_SIGNED:
          return 'warning';
        case AgencyConstants.AcceptanceStatus.CANCELLED:
          return 'danger';
        case AgencyConstants.AcceptanceStatus.COMPLETED:
          return 'success';
        case AgencyConstants.AcceptanceStatus.EXPIRED:
          return 'danger';
        default:
          return '';
      }
    },
    // kiem tra vai tro cua AGENCY
    checkRole: (agency, role) => {
      return (agency?.commissions ?? []).some((commission) => commission?.role === role);
    },
    // kiem tra co the huy hop dong
    checkContractCanCancel: (status) => {
      return [
        AgencyConstants.ContractStatus.CREATED,
        AgencyConstants.ContractStatus.ADMIN_SIGNED,
        AgencyConstants.ContractStatus.AGENCY_SIGNED,
      ].includes(status);
    },
    // kiem tra co the xoa hop dong
    checkContractCanDelete: (status) => {
      return [
        AgencyConstants.ContractStatus.CREATED,
        AgencyConstants.ContractStatus.ADMIN_SIGNED,
        AgencyConstants.ContractStatus.AGENCY_SIGNED,
        AgencyConstants.ContractStatus.CANCELLED,
      ].includes(status);
    },
    // lay link gioi thieu cua AGENCY
    getSignUpLink: (agency) => {
      const domain = AppConfigs.env.domainUrl || '';
      let signUpName = '';
      if (agency?.primaryRole === AgencyConstants.AgencyRole.SALE) {
        signUpName = 'sign-up-sale';
      } else {
        const commissions = agency?.commissions ?? [];
        const firstCommissionRole = _.first(commissions)?.role;
        if (firstCommissionRole === AgencyConstants.AgencyRole.INVESTOR) {
          signUpName = 'sign-up-investor';
        } else if (firstCommissionRole === AgencyConstants.AgencyRole.COINVESTOR) {
          signUpName = 'sign-up-coinvestor';
        } else if (firstCommissionRole === AgencyConstants.AgencyRole.GROUP) {
          signUpName = 'sign-up-group';
        }
      }
      const appendReferralCode = agency?.referralCode
        ? `?referralCode=${agency?.referralCode}`
        : '';
      return `${domain}/auth/${signUpName}${appendReferralCode}`;
    },
    // ten trang thai doi soat
    getReconciliationStatusName: (status) => {
      switch (status) {
        case AgencyConstants.AgencyReconciliationStatus.CREATED:
          return 'Đã tạo';
        case AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED:
          return 'Đã ký bởi NĐH';
        case AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED:
          return 'Đã ký bởi đối tác';
        default:
          return '';
      }
    },
    // mau sac trang thai doi soat
    getReconciliationStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.AgencyReconciliationStatus.CREATED:
          return 'primary';
        case AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED:
          return 'warning';
        case AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED:
          return 'success';
        default:
          return '';
      }
    },
    // lay ten loai bao cao doi soat
    getReconciliationRoleName: (role) => {
      switch (role) {
        case AgencyConstants.AgencyReconciliationRole.SALE:
          return 'Đối soát đại lý bán hàng';
        case AgencyConstants.AgencyReconciliationRole.INVESTOR:
          return 'Đối soát hoa hồng nhà đầu tư nhượng quyền';
        case AgencyConstants.AgencyReconciliationRole.COINVESTOR:
          return 'Đối soát hoa hồng nhà đầu tư liên kết';
        case AgencyConstants.AgencyReconciliationRole.GROUP:
          return 'Đối soát hoa hồng NĐT liên kết';
        default:
          return '';
      }
    },
    // lay ten loai AGENCY
    getAgencyRoleName: (role) => {
      switch (role) {
        case AgencyConstants.AgencyRole.SALE:
          return 'Đại lý bán hàng';
        case AgencyConstants.AgencyRole.INVESTOR:
          return 'NĐT nhượng quyền';
        case AgencyConstants.AgencyRole.COINVESTOR:
          return 'Nhà đầu tư liên kết';
        case AgencyConstants.AgencyRole.GROUP:
          return 'NĐT liên kết';
        case AgencyConstants.AgencyRole.LANDLORD:
          return 'Chủ mặt bằng';
        case AgencyConstants.AgencyRole.VOUCHER_PARTNER:
          return 'Đối tác mua voucher';
        default:
          return '';
      }
    },
    getShortAgencyRoleName: (role) => {
      switch (role) {
        case AgencyConstants.AgencyRole.SALE:
          return 'Đại lý';
        case AgencyConstants.AgencyRole.INVESTOR:
          return 'Nhà đầu tư';
        case AgencyConstants.AgencyRole.COINVESTOR:
          return 'Nhà đầu tư';
        case AgencyConstants.AgencyRole.GROUP:
          return 'Nhà đầu tư';
        case AgencyConstants.AgencyRole.LANDLORD:
          return 'Chủ mặt bằng';
        default:
          return '';
      }
    },
    getAgencyRoleShortName: (role) => {
      switch (role) {
        case AgencyConstants.AgencyRole.SALE:
          return 'đại lý';
        case AgencyConstants.AgencyRole.INVESTOR:
          return 'NĐT nhượng quyền';
        case AgencyConstants.AgencyRole.COINVESTOR:
          return 'NĐT liên kết';
        case AgencyConstants.AgencyRole.GROUP:
          return 'NĐT liên kết';
        case AgencyConstants.AgencyRole.LANDLORD:
          return 'chủ mặt bằng';
        default:
          return '';
      }
    },
    // tai xuong file
    downloadFile: (url, filename) => {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename || 'download');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // kiem tra co the chinh sua doi soat
    checkReconciliationCanEdit: (status) => {
      return ![AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED].includes(status);
    },
    // kiem tra co the xoa doi soat
    checkReconciliationCanDelete: (status) => {
      return ![AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED].includes(status);
    },
    // kiem tra AGENCY co du thong tin de thuc hien mua hang?
    checkAgencyEnoughInfoToPurchase: (agency) => {
      let arrInfo = [];
      if (!!agency) {
        const {
          type,
          areaId,
          address,
          taxCode,
          idCardType,
          idCardNumber,
          idCardPlaceOfIssue,
          idCardIssueDate,
          idCardDocuments,
          legalRepresentative,
          legalPosition,
          bankAccounts,
          dob,
          gender,
          country,
        } = agency;
        if (!Utils.isValid(dob) && type === AgencyConstants.AgencyType.INDIVIDUAL) {
          arrInfo.push('ngày sinh');
        }
        if (!Utils.isValid(gender) && type === AgencyConstants.AgencyType.INDIVIDUAL) {
          arrInfo.push('giới tính');
        }
        if (!Utils.isValid(areaId) && country === 'VN') {
          arrInfo.push('tỉnh/thành phố, phường/xã');
        }
        if (!Utils.isValid(address)) {
          if (country === 'VN') {
            arrInfo.push('địa chỉ cụ thể');
          } else {
            arrInfo.push('địa chỉ cư trú');
          }
        }
        if (!Utils.isValid(taxCode) && type === AgencyConstants.AgencyType.ORGANIZATION) {
          arrInfo.push('mã số thuế');
        }
        if (type === AgencyConstants.AgencyType.INDIVIDUAL) {
          if (!Utils.isValid(idCardNumber)) {
            arrInfo.push(idCardType !== 'HC' ? 'số CCCD' : 'số hộ chiếu');
          }
          if (!Utils.isValid(idCardPlaceOfIssue) && idCardType !== 'HC') {
            arrInfo.push('nơi cấp');
          }
          if (!Utils.isValid(idCardIssueDate)) {
            arrInfo.push('ngày cấp');
          }
        }
        if (!Utils.isValid(idCardDocuments)) {
          arrInfo.push(
            type === AgencyConstants.AgencyType.INDIVIDUAL
              ? idCardType !== 'HC'
                ? 'ảnh CCCD'
                : 'ảnh hộ chiếu'
              : 'giấy phép kinh doanh'
          );
        }
        if (bankAccounts && bankAccounts.length === 0) {
          arrInfo.push('thông tin tài khoản ngân hàng');
        }
        if (type === AgencyConstants.AgencyType.INDIVIDUAL) {
        } else if (type === AgencyConstants.AgencyType.ORGANIZATION) {
          if (!Utils.isValid(legalRepresentative)) {
            arrInfo.push('người đại diện theo pháp luật');
          }
          if (!Utils.isValid(legalPosition)) {
            arrInfo.push('chức vụ người đại diện');
          }
        }
      }

      return arrInfo;
    },
    // lay ten mau hop dong
    getContractRoleName: (role) => {
      switch (role) {
        case AgencyConstants.ContractRole.SALE:
          return 'Hợp đồng môi giới và tư vấn';
        case AgencyConstants.ContractRole.INVESTOR:
          return 'Hợp đồng bán nhượng quyền';
        case AgencyConstants.ContractRole.COINVESTOR:
          return 'Hợp đồng bán liên kết';
        case AgencyConstants.ContractRole.GROUP:
          return 'Hợp đồng hợp tác kinh doanh';
        case AgencyConstants.ContractRole.LANDLORD:
          return 'Hợp đồng hợp tác mặt bằng';
        case AgencyConstants.ContractRole.CHARGEPOINT:
          return 'Hợp đồng bán trụ sạc';
        case AgencyConstants.ContractRole.FRANCHISE:
          return 'Hợp đồng nhượng quyền';
        case AgencyConstants.ContractRole.MAINTAINER:
          return 'Hợp đồng KTV';
        default:
          return '';
      }
    },
    // lay ten mau bien ban nghiem thu
    getAcceptanceRoleName: (role) => {
      switch (role) {
        case AgencyConstants.AcceptanceRole.TECHNICAL:
          return 'Nghiệm thu kỹ thuật';
        case AgencyConstants.AcceptanceRole.FINANCIAL:
          return 'Nghiệm thu thanh toán';
        default:
          return '';
      }
    },
    // kiem tra xem NDT co hop dong CTV chua
    checkAgencyHasSaleContract: (agency) => {
      return agency?.contracts?.find(contract => contract.contractRole === AgencyConstants.ContractRole.SALE && contract.status === AgencyConstants.ContractStatus.COMPLETED);
    },
    // kiem tra xem NDT co hop dong nhuong quyen chua
    checkAgencyHasFranchiseContract: (agency) => {
      return agency?.contracts?.find(contract => contract.contractRole === AgencyConstants.ContractRole.FRANCHISE && contract.status === AgencyConstants.ContractStatus.COMPLETED);
    },

    // ---- PREMISE ----
    // ten trang thai mat bang
    getPremiseStatusName: (status) => {
      switch (status) {
        case AgencyConstants.PremiseStatus.AVAILABLE:
          return 'Chưa thuê';
        case AgencyConstants.PremiseStatus.RENTED:
          return 'Đã thuê';
        case AgencyConstants.PremiseStatus.DELETED:
          return 'Đã bị xóa';
        default:
          return '';
      }
    },
    // mau sac trang thai mat bang
    getPremiseStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.PremiseStatus.AVAILABLE:
          return 'secondary';
        case AgencyConstants.PremiseStatus.RENTED:
          return 'success';
        case AgencyConstants.PremiseStatus.DELETED:
          return 'danger';
        default:
          return '';
      }
    },
    // ten trang thai hop dong mat bang
    getPremiseContractStatusName: (contractStatus) => {
      switch (contractStatus) {
        case AgencyConstants.PremiseContractStatus.CREATED:
          return 'Đã tạo';
        case AgencyConstants.PremiseContractStatus.ADMIN_SIGNED:
          return 'Đã ký bởi NĐH';
        case AgencyConstants.PremiseContractStatus.AGENCY_SIGNED:
          return 'Đã ký bởi chủ MB';
        case AgencyConstants.PremiseContractStatus.CANCELLED:
          return 'Đã hủy';
        case AgencyConstants.PremiseContractStatus.COMPLETED:
          return 'Hoàn thành';
        case AgencyConstants.PremiseContractStatus.EXPIRED:
          return 'Đã hết hạn';
        default:
          return '';
      }
    },
    // mau sac trang thai hop dong mat bang
    getPremiseContractStatusColor: (contractStatus) => {
      switch (contractStatus) {
        case AgencyConstants.PremiseContractStatus.CREATED:
          return 'primary';
        case AgencyConstants.PremiseContractStatus.ADMIN_SIGNED:
          return 'primary';
        case AgencyConstants.PremiseContractStatus.AGENCY_SIGNED:
          return 'primary';
        case AgencyConstants.PremiseContractStatus.CANCELLED:
          return 'danger';
        case AgencyConstants.PremiseContractStatus.COMPLETED:
          return 'success';
        case AgencyConstants.PremiseContractStatus.EXPIRED:
          return 'secondary';
        default:
          return '';
      }
    },

    // ---- TRANSACTION ----
    // lay ten trang thai giao dich
    getTransactionStatusName: (status) => {
      switch (status) {
        case AgencyConstants.AgencyTransactionStatus.PAID:
          return 'Đã thanh toán';
        case AgencyConstants.AgencyTransactionStatus.REQUESTED:
          return 'Đợi xử lý';
        case AgencyConstants.AgencyTransactionStatus.PROCESSING:
          return 'Đang xử lý';
        case AgencyConstants.AgencyTransactionStatus.REJECTED:
          return 'Từ chối';
        case AgencyConstants.AgencyTransactionStatus.FAILED:
          return 'Thất bại';
        default:
          return '';
      }
    },
    // lay mau sac cua trang thai giao dich
    getTransactionStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.AgencyTransactionStatus.PAID:
          return 'success';
        case AgencyConstants.AgencyTransactionStatus.REQUESTED:
          return 'warning';
        case AgencyConstants.AgencyTransactionStatus.PROCESSING:
          return 'primary';
        case AgencyConstants.AgencyTransactionStatus.REJECTED:
          return 'danger';
        case AgencyConstants.AgencyTransactionStatus.FAILED:
          return 'secondary';
        default:
          return '';
      }
    },
    // ten trang thai giao dich rut tien
    getAgencyPaymentStatusName: (status) => {
      switch (status) {
        case AgencyConstants.AgencyPaymentStatus.REQUESTED:
          return 'Đợi xử lý';
        case AgencyConstants.AgencyPaymentStatus.PROCESSING:
          return 'Đang xử lý';
        case AgencyConstants.AgencyPaymentStatus.PAID:
          return 'Đã thanh toán';
        case AgencyConstants.AgencyPaymentStatus.REJECTED:
          return 'Từ chối';
        case AgencyConstants.AgencyPaymentStatus.FAILED:
          return 'Thất bại';
        default:
          return '';
      }
    },
    // mau sac trang thai giao dich rut tien
    getAgencyPaymentStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.AgencyPaymentStatus.REQUESTED:
          return 'warning';
        case AgencyConstants.AgencyPaymentStatus.PROCESSING:
          return 'info';
        case AgencyConstants.AgencyPaymentStatus.PAID:
          return 'success';
        case AgencyConstants.AgencyPaymentStatus.REJECTED:
          return 'danger';
        case AgencyConstants.AgencyPaymentStatus.FAILED:
          return 'secondary';
        default:
          return '';
      }
    },
    // ten hinh thuc phat hanh lo voucher
    getVoucherBatchTypeName: (type) => {
      switch (type) {
        case AgencyConstants.VoucherBatchType.SELF_CLAIM:
          return 'Tự nhận';
        case AgencyConstants.VoucherBatchType.PARTNER:
          return 'Đối tác';
        case AgencyConstants.VoucherBatchType.INTERNAL:
          return 'Nội bộ';
        default:
          return '';
      }
    },
    // ten trang thai lo voucher
    getVoucherBatchStatusName: (status) => {
      switch (status) {
        case AgencyConstants.VoucherBatchStatus.NEW:
          return 'Chưa tạo voucher';
        case AgencyConstants.VoucherBatchStatus.ACTIVE:
          return 'Còn hiệu lực';
        case AgencyConstants.VoucherBatchStatus.EXPIRED:
          return 'Hết hiệu lực';
        case AgencyConstants.VoucherBatchStatus.DEPLETED:
          return 'Đã sử dụng hết';
        case AgencyConstants.VoucherBatchStatus.DELETED:
          return 'Đã xóa';
        case AgencyConstants.VoucherBatchStatus.INACTIVE:
          return 'Ngừng hoạt động';
        default:
          return '';
      }
    },
    // mau sac trang thai lo voucher
    getVoucherBatchStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.VoucherBatchStatus.NEW:
          return 'warning';
        case AgencyConstants.VoucherBatchStatus.ACTIVE:
          return 'success';
        case AgencyConstants.VoucherBatchStatus.EXPIRED:
          return 'secondary';
        case AgencyConstants.VoucherBatchStatus.DEPLETED:
          return 'secondary';
        case AgencyConstants.VoucherBatchStatus.DELETED:
          return 'danger';
        case AgencyConstants.VoucherBatchStatus.INACTIVE:
          return 'danger';
        default:
          return '';
      }
    },
    // ten loai voucher
    getVoucherTypeName: (type) => {
      switch (type) {
        case AgencyConstants.VoucherType.MONEY:
          return 'Tiền sạc (VNĐ)';
        case AgencyConstants.VoucherType.ENERGY:
          return 'Điện sạc (kWh)';
        default:
          return '';
      }
    },
    // ten doi tuong nhan voucher
    getVoucherIdentityTypeName: (type) => {
      switch (type) {
        case AgencyConstants.VoucherIdentityType.DRIVER:
          return 'Khách hàng';
        case AgencyConstants.VoucherIdentityType.VEHICLE:
          return 'Xe';
        case AgencyConstants.VoucherIdentityType.ANY:
          return 'Chưa xác định';
        default:
          return '';
      }
    },
    // ten trang thai voucher
    getVoucherStatusName: (status) => {
      switch (status) {
        case AgencyConstants.VoucherStatus.NEW:
          return 'Đã tạo';
        case AgencyConstants.VoucherStatus.VALID:
          return 'Còn hiệu lực';
        case AgencyConstants.VoucherStatus.EXPIRED:
          return 'Hết hiệu lực';
        case AgencyConstants.VoucherStatus.INVALID:
          return 'Ngừng hoạt động';
        default:
          return '';
      }
    },
    // mau sac trang thai voucher
    getVoucherStatusColor: (status) => {
      switch (status) {
        case AgencyConstants.VoucherStatus.NEW:
          return 'primary';
        case AgencyConstants.VoucherStatus.VALID:
          return 'success';
        case AgencyConstants.VoucherStatus.EXPIRED:
          return 'secondary';
        case AgencyConstants.VoucherStatus.INVALID:
          return 'danger';
        default:
          return '';
      }
    },
    getCreatorUserId: (createdBy) => {
      if (!createdBy) {
        return null;
      }
      if (typeof createdBy === 'number') {
        return createdBy;
      }
      return createdBy?.userId ?? null;
    },
    getVoucherBatchCreator: (row) => {
      if (row?.creator?.fullname) {
        return row.creator;
      }
      if (row?.createdBy?.fullname) {
        return row.createdBy;
      }
      return null;
    },
    getVoucherCreator: (row) => {
      if (row?.creator?.fullname) {
        return row.creator;
      }
      if (row?.createdBy?.fullname) {
        return row.createdBy;
      }
      if (row?.voucherBatch?.creator?.fullname) {
        return row.voucherBatch.creator;
      }
      if (row?.voucherBatch?.createdBy?.fullname) {
        return row.voucherBatch.createdBy;
      }
      return null;
    },
    enrichRecordsWithCreators: async (records, { getCreator, getCreatedById }) => {
      const creatorIds = [
        ...new Set(
          records
            .filter((record) => !getCreator(record) && getCreatedById(record))
            .map((record) => AgencyHelper.Utils.getCreatorUserId(getCreatedById(record)))
            .filter(Boolean)
        ),
      ];

      if (creatorIds.length === 0) {
        return records;
      }

      const creatorMap = {};
      await Promise.all(
        creatorIds.map(async (userId) => {
          const { users } = await SystemHelper.API.User.requestGetUserList({ userId, limit: 1 });
          const user = users?.[0];
          if (user) {
            creatorMap[userId] = user;
          }
        })
      );

      return records.map((record) => {
        const existingCreator = getCreator(record);
        if (existingCreator) {
          return record.creator?.fullname ? record : { ...record, creator: existingCreator };
        }

        const userId = AgencyHelper.Utils.getCreatorUserId(getCreatedById(record));
        const creator = userId ? creatorMap[userId] : null;
        return creator ? { ...record, creator } : record;
      });
    },
    enrichVoucherBatchesWithCreators: async (voucherBatches) => {
      return AgencyHelper.Utils.enrichRecordsWithCreators(voucherBatches, {
        getCreator: AgencyHelper.Utils.getVoucherBatchCreator,
        getCreatedById: (row) => row?.createdBy,
      });
    },
    enrichVouchersWithCreators: async (vouchers) => {
      return AgencyHelper.Utils.enrichRecordsWithCreators(vouchers, {
        getCreator: AgencyHelper.Utils.getVoucherCreator,
        getCreatedById: (row) => row?.createdBy ?? row?.voucherBatch?.createdBy,
      });
    },
  },

  // MARK: ---- NAVIGATION ----
  Navigation: {
    // chuyen den man hinh chi tiet agency
    navigateToAgencyDetail: (router, agency) => {
      if (agency) {
        const role = agency?.primaryRole;
        const agencyId = agency?.agencyId;
        if (Utils.isValid(agencyId) && Utils.isValid(role)) {
          const url = `/${role?.toLowerCase()}/${agencyId}`;
          if (router) {
            router.navigate(url);
          } else {
            Utils.openInNewTab(url);
          }
        }
      }
    },
    // chuyen den man hinh chinh sua agency
    navigateToAgencyEdit: (router, agency) => {
      if (Utils.isValid(agency)) {
        const role = agency?.primaryRole;
        const agencyId = agency?.agencyId;
        if (!Utils.isValid(role)) {
          return;
        }
        let url = '';
        if (role === AgencyConstants.AgencyRole.CHARGEPOINT) {
          url = `${AppRoute.chargePointPartnerList}/${agencyId}/edit`;
        } else {
          url = `/${role?.toLowerCase()}/${agencyId}/edit`;
        }
        if (router) {
          router.navigate(url);
        } else {
          Utils.openInNewTab(url);
        }
      }
    },
    // chuyen den man hinh chi tiet bao cao doi soat
    navigateToReconciliationDetail: (router, reconciliationId) => {
      if (reconciliationId) {
        if (router) {
          router?.navigate(`${AppRoute.saleReport}/${reconciliationId}`);
        } else {
          Utils.openInNewTab(`${AppRoute.saleReport}/${reconciliationId}`);
        }
      }
    },
  },

  // MARK: ---- UI ----
  UI: {
    // hien dialog xac nhan xoa doi soat
    showDialogConfirmDeleteReconciliation: (reconciliationDetail, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogDeleteVehicle} />}
          title="Xoá đối soát"
          contentEl={
            <>
              Bạn có chắc muốn xoá đối soát tháng{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                {reconciliationDetail?.month}
              </span>{' '}
              của đối tác{' '}
              <span
                className="cursor-pointer hover-opacity-60"
                style={UIHelper.buildFontStyle('700', '14px', AppColors.primary)}
                onClick={() => {
                  AgencyHelper.Navigation.navigateToAgencyDetail(
                    null,
                    reconciliationDetail?.agency
                  );
                }}
              >
                {reconciliationDetail?.agency?.name}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const result = await AgencyHelper.API.requestDeleteReconciliation(
              reconciliationDetail?.reconciliationId
            );
            if (result && _.isBoolean(result)) {
              ToastHelper.showSuccess('Xoá đối soát thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result || 'Xoá đối soát thất bại');
            }
          }}
        />,
        'md'
      );
    },
    // hien dialog xac nhan tao hop dong voi AGENCY SALE
    showDialogConfirmCreateContractWithSale: (sale, onDone) => {
      AppCustomDialogHelper.show(
        '',
        <AgencySaleDialogView
          iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
          title="Tạo hợp đồng"
          contentEl={
            <>
              Bạn có chắc muốn tạo hợp đồng với đại lý{' '}
              <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[800])}>
                {sale?.name}
              </span>
              ?
            </>
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async () => {
            AppCustomDialogHelper.hide();
            const paramCreateContract = {
              agencyId: sale?.agencyId,
              operatorId: sale?.operatorId,
            };
            const result = await AgencyHelper.API.requestCreateSaleContract(paramCreateContract);
            if (result && _.isObject(result)) {
              ToastHelper.showSuccess('Tạo hợp đồng thành công');
              if (onDone) {
                onDone();
              }
            } else {
              ToastHelper.showError(result ?? 'Tạo hợp đồng thất bại');
            }
          }}
        />,
        'md',
        false,
        true
      );
    },
    // hien dialog xac nhan tao hop dong voi AGENCY de ban hang
    showDialogConfirmCreateContractWithAgency: (agency, onDone, contract, onCheck, contractRole) => {
      console.log({ agency, contract });
      AppCustomDialogHelper.show(
        '',
        <AgencyCreateContractView
          agency={agency}
          contract={contract}
          contractRole={contractRole}
          title={
            !Utils.isValid(contract)
              ? contractRole !== AgencyConstants.ContractRole.FRANCHISE ? 'Tạo hợp đồng CTV' : 'Tạo hợp đồng nhượng quyền'
              : contract?.contractRole !== AgencyConstants.ContractRole.FRANCHISE ? 'Cập nhật hợp đồng CTV' : 'Cập nhật hợp đồng nhượng quyền'
          }
          contentEl={
            !Utils.isValid(contract) ? (
              <>
                Bạn muốn tạo hợp đồng
                {contractRole !== AgencyConstants.ContractRole.FRANCHISE ? ' CTV ' : ' nhượng quyền '}
                với{' '}
                {AgencyHelper.Utils.getAgencyRoleName(agency?.primaryRole)?.toLowerCase()}{' '}
                <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                  {agency?.name}
                </span>
                ?
              </>
            ) : null
          }
          onCancel={() => {
            AppCustomDialogHelper.hide();
          }}
          onConfirm={async (param) => {
            if (
              param?.contractType === AgencyConstants.ContractType.DIGITAL &&
              !agency?.hsmAgreementUUID
            ) {
              ToastHelper.showError(
                `${t(`agencyRoleDropdownTitle_${agency?.primaryRole}`)} chưa có chữ ký số`
              );
            } else {
              if (onCheck) {
                await onCheck();
              }
              let result = null;
              if (Utils.isValid(contract)) {
                result = await AgencyHelper.API.requestUpdateContract(
                  contract?.contractId,
                  param
                );
              } else {
                const paramCreateContract = {
                  agencyId: agency?.agencyId,
                  operatorId: agency?.operatorId,
                  ...param,
                  ...(contractRole === AgencyConstants.ContractRole.FRANCHISE
                    ? { contractRole: AgencyConstants.ContractRole.FRANCHISE }
                    : {}),
                };
                if (contractRole !== AgencyConstants.ContractRole.FRANCHISE) {
                  result = await AgencyHelper.API.requestCreateSaleContract(paramCreateContract);
                } else {
                  result = await AgencyHelper.API.requestCreateFranchiseContract(paramCreateContract);
                }
              }
              AppCustomDialogHelper.hide();
              if (result && _.isObject(result)) {
                ToastHelper.showSuccess(
                  !Utils.isValid(contract)
                    ? 'Tạo hợp đồng thành công'
                    : 'Cập nhật hợp đồng thành công'
                );
                if (onDone) {
                  onDone();
                }
              } else {
                ToastHelper.showError(
                  result || (!Utils.isValid(contract)
                    ? 'Tạo hợp đồng thất bại'
                    : 'Cập nhật hợp đồng không thành công')
                );
              }
            }
          }}
        />,
        'md',
        false,
        true
      );
    },
    // hien dialog tao lai doi soat
    showDialogCreateReconciliation: (primaryRole, reconciliation, onDone) => {
      AppCustomDialogHelper.show(
        'Tạo lại đối soát',
        <DialogCreateAgencyReconciliation
          primaryRole={primaryRole}
          item={reconciliation}
          onCancel={() => AppCustomDialogHelper.hide()}
          onDone={() => {
            onDone();
            AppCustomDialogHelper.hide();
          }}
        />,
        'md',
        false,
        true
      );
    },
    // dung hoat dong lo voucher
    showDialogConfirmStopVoucherBatch: (row, onCompleted = () => { }) => {
      AppDialogHelper.show(
        'Ngừng hoạt động',
        `Bạn có chắc muốn ngừng hoạt động lô voucher <span class="font-weight-boldest text-gray-800">
        ${row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : ''}
        </span> không?`,
        [
          {
            title: 'Hủy bỏ',
            type: 'neutral',
            onClick: () => {
              AppDialogHelper.hide();
            },
          },
          {
            title: 'Ngừng hoạt động',
            type: 'negative',
            onClick: async () => {
              AppDialogHelper.hide();
              const res = await AgencyHelper.API.requestUpdateVoucherBatch(row?.voucherBatchId, {
                status: 'INACTIVE',
              });
              if (res && _.isBoolean(res)) {
                ToastHelper.showSuccess(`Ngừng hoạt động lô voucher thành công`);
                onCompleted();
              } else {
                ToastHelper.showError(res || `Ngừng hoạt động lô voucher thất bại`);
              }
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogStopAgency
      );
    },
    // khoi phuc hoạt dong lo voucher
    showDialogConfirmActiveVoucherBatch: (row, onCompleted = () => { }) => {
      AppDialogHelper.show(
        'Khôi phục hoạt động',
        `Bạn có chắc muốn khôi phục hoạt động lô voucher <span class="font-weight-boldest text-gray-800">
        ${row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : ''}
        </span> không?`,
        [
          {
            title: 'Hủy bỏ',
            type: 'neutral',
            onClick: () => {
              AppDialogHelper.hide();
            },
          },
          {
            title: 'Khôi phục',
            type: 'success',
            onClick: async () => {
              AppDialogHelper.hide();
              const res = await AgencyHelper.API.requestUpdateVoucherBatch(row?.voucherBatchId, {
                status: 'ACTIVE',
              });
              if (res && _.isBoolean(res)) {
                ToastHelper.showSuccess(`Khôi phục lô voucher thành công`);
                onCompleted();
              } else {
                ToastHelper.showError(res || `Khôi phục lô voucher thất bại`);
              }
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogActiveAgency
      );
    },
    // xoa lo voucher
    showDialogConfirmDeleteVoucherBatch: (row, onCompleted = () => { }) => {
      AppDialogHelper.show(
        `Xóa lô voucher`,
        `Bạn có chắc muốn xóa lô voucher <span class="font-weight-boldest text-gray-800">
        ${row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : ''}
        </span> không?`,
        [
          {
            title: 'Hủy bỏ',
            type: 'neutral',
            onClick: () => {
              AppDialogHelper.hide();
            },
          },
          {
            title: 'Xóa',
            type: 'negative',
            onClick: async () => {
              AppDialogHelper.hide();
              const res = await AgencyHelper.API.requestDeleteVoucherBatch(row?.voucherBatchId);
              if (res && _.isBoolean(res)) {
                ToastHelper.showSuccess(`Xoá lô voucher thành công`);
                onCompleted();
              } else {
                ToastHelper.showError(res || `Xóa lô voucher thất bại`);
              }
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogDeleteVehicle
      );
    },
    // NDT NQ chua ky hop dong NQ
    showDialogRequireFranchiseContract: (row, onRefresh) => {
      AppDialogHelper.show(
        `Không thể tạo đơn hàng cho nhà đầu tư`,
        `Không thể tạo đơn hàng do nhà đầu tư chưa ký hợp đồng nhượng quyền với nhà điều hành.`,
        [
          {
            title: 'Hủy bỏ',
            type: 'neutral',
            onClick: () => {
              AppDialogHelper.hide();
            },
          },
          {
            title: 'Tạo hợp đồng',
            type: 'primary',
            onClick: async () => {
              AppDialogHelper.hide();
              AgencyHelper.UI.showDialogConfirmCreateContractWithAgency(
                row,
                () => {
                  if (onRefresh) onRefresh();
                },
                undefined,
                null,
                AgencyConstants.ContractRole.FRANCHISE,
              );
            },
          },
        ],
        false,
        AppResource.images.dialogIcons.dialogNoticeTriangular
      );
    },
  },
};

export default AgencyHelper;
